<div class="container" *ngIf="prescriberDetails$ | async as details">
  <div class="loading-overlay" *ngIf="details.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div class="container__form" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="ceIdInput" text="CE ID"> </kendo-label>
        <kendo-textbox #ceIdInput class="form-field" formControlName="ceId">
        </kendo-textbox>
      </kendo-formfield>
      <span *ngIf="ceId.invalid && ceId.dirty" class="validation-error">
        {{ getControlErrorMsg(ceId) }}
      </span>
    </div>
  </div>

  <kendo-dialog-actions class="container__toolbar">
    <div class="container__buttons">
      <button kendoButton class="container__button" (click)="close()">
        Cancel
      </button>
      <button
        kendoButton
        [primary]="true"
        class="container__button"
        (click)="save()"
        [disabled]="details.pending || !details.data || !npi"
      >
        Save
      </button>
    </div>
  </kendo-dialog-actions>
</div>
